import React, { Fragment, memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  changeApiKey,
  changeOrganization,
  changeRequestStatus,
  selectRequestStatus,
  selectSettings,
  setSettings,
} from '../../../../reducers/workspace/settings/open-ai-settings-form'
import { selectWorkspace } from '../../../../reducers/workspace/workspace'
import { normalize } from '../../../../utils/helper'
import { REQUEST_STATUSES } from '../../../../reducers/reducer-helper'
import { updateWorkspaceOpenAiSettings } from './slice'
import Loader from '../../../common/loader/Loader'

function OpenAi() {
  const dispatch = useDispatch()
  const workspace = useSelector(selectWorkspace)
  const requestStatus = useSelector(selectRequestStatus)

  const formData = useSelector(selectSettings)

  useEffect(() => {
    dispatch(
      setSettings({
        apiKey: workspace.openAiConfig.apiKey ?? '',
        organization: workspace.openAiConfig.organization ?? '',
      }),
    )
  }, [workspace])

  const showSaveButton = () => {
    return (
      formData.apiKey !== normalize(workspace.openAiConfig.apiKey) ||
      formData.organization !== normalize(workspace.openAiConfig.organization)
    )
  }

  const saveSettings = (event) => {
    event.preventDefault()
    dispatch(changeRequestStatus({ status: REQUEST_STATUSES.PENDING }))
    dispatch(
      updateWorkspaceOpenAiSettings({
        apiKey: formData.apiKey,
        organization: formData.organization,
      }),
    )
  }

  const changeOrganizationProcess = (event) => {
    event.preventDefault()
    dispatch(changeOrganization({ organization: event.target.value }))
  }

  const changeApiKeyProcess = (event) => {
    event.preventDefault()
    dispatch(changeApiKey({ apiKey: event.target.value }))
  }

  return (
    <>
      <div className="mx-auto space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none">
        <div>
          <div className={'flex flex-col pb-6 border-b border-gray-200'}>
            <h2 className="text-base font-semibold leading-7 text-gray-900">Open AI Keys</h2>
            <p className="mt-1 text-sm leading-6 text-gray-500">Your personal Open AI Keys</p>
          </div>
          <dl className="max-w-4xl text-sm leading-6">
            <form
              onSubmit={saveSettings}
              className="mt-6 max-w-4xl space-y-6 divide-y divide-gray-100 text-sm leading-6"
            >
              {requestStatus === REQUEST_STATUSES.PENDING && <Loader fullSize={true} />}
              {requestStatus !== REQUEST_STATUSES.PENDING && (
                <>
                  <div className="mt-8 flow-root">
                    <div className="sm:flex pt-6">
                      <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Open AI API Key</dt>
                      <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
                        <input
                          id="workspace-ai-api-key"
                          name="workspace-ai-api-key"
                          type="string"
                          value={formData.apiKey}
                          onChange={changeApiKeyProcess}
                          placeholder="Open AI API Key"
                          autoComplete="workspace-ai-api-key"
                          className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </dd>
                    </div>
                    <div className="sm:flex pt-6">
                      <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Organization</dt>
                      <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
                        <input
                          id="workspace-ai-organization"
                          name="workspace-ai-organization"
                          type="string"
                          value={formData.organization}
                          onChange={changeOrganizationProcess}
                          placeholder="Open AI organization"
                          autoComplete="workspace-ai-organization"
                          className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </dd>
                    </div>
                  </div>
                  {showSaveButton() && (
                    <div className="pt-6 sm:flex">
                      <dt className="font-medium text-gray-500 sm:w-64 sm:flex-none sm:pr-6"></dt>
                      <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
                        <button
                          type="submit"
                          className={`flex items-center justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                        >
                          <span>Save changes</span>
                        </button>
                      </dd>
                    </div>
                  )}
                </>
              )}
            </form>
          </dl>
        </div>
      </div>
    </>
  )
}

export default memo(OpenAi)
